/**
 * The one sentence the shared table says on its own: what an empty table means
 * when the read behind it failed.
 *
 * 🔴 Until 2026-10-20 `ui/Table.tsx` printed the screen's `emptyMessage` whenever
 * `data` was empty and nothing was loading — on a failed read too, so eight screens
 * said «No campaigns under this account», «No agents yet», «Nobody is seated yet»
 * over a 502 (spa-review #7). Two of them (Agents, Proxies) had no banner above the
 * table either, so the failure was invisible. The sentence lives here, where a
 * runner reads it; the table only chooses it when the screen says the read failed.
 */
export const NOT_READ =
	"Not read: this list could not be read, so an empty table here is not an empty list.";

/**
 * 🔴 The one decision: what the empty row says. `ui/Table.tsx` renders this and
 * decides nothing itself, so both sides are a function a runner calls — a failed
 * read says NOT_READ whatever the screen's sentence is, and a successful empty read
 * says the screen's sentence and never NOT_READ.
 */
export function emptyCellText(failed: boolean, emptyMessage: string): string {
	return failed ? NOT_READ : emptyMessage;
}

/**
 * Under a paged table (`pageOf`, lib/table-page.ts): which rows are on screen, out of
 * the rows read. «read» and never «of N» alone — the rows are the ones this screen
 * fetched, and X gives no total while paging (`MORE_BANNER` in campaign-copy.ts).
 */
export function pageLabel(from: number, to: number, read: number): string {
	return `Rows ${String(from)}–${String(to)} of the ${String(read)} read.`;
}

export const PREVIOUS_PAGE = "Previous page";
export const NEXT_PAGE = "Next page";
